import React, { useState, useContext, useEffect } from 'react'
import { M_Table, LoadingContext, NavigateContext, M_MessageBoard, M_DrawerTableTextField, M_Button, BufferService, M_Select, M_InputTextField, M_TextArea } from 'src/components/M_Components'
import { useTranslation } from 'react-i18next'
import { DeleteOutline, EuroSymbol } from '@mui/icons-material'

const Body = ({ dataChangeState, dataMovements, setDataMovements, t, optionsTrinomial, orderServiceAddresses }) => {
  const selectedSubcontractedCosts = dataMovements.SubcontractedCosts || []

  const setSubcontractedCosts = (costs) => {
    const uniqueCosts = (costs || []).reduce((acc, cost) => {
      if (!cost?.CostsId || acc.some(item => item.CostsId === cost.CostsId)) return acc

      return [...acc, {
        CostsId: cost.CostsId,
        Descriptive: cost.Descriptive || cost.Costs || cost.Name || '',
        AddicionalPrice: cost.AddicionalPrice ?? cost.Value ?? null,
      }]
    }, [])

    setDataMovements(prev => ({
      ...prev,
      SubcontractedCosts: uniqueCosts
    }))
  }

  const removeSubcontractedCost = (costsId) => {
    setDataMovements(prev => ({
      ...prev,
      SubcontractedCosts: (prev.SubcontractedCosts || []).filter(cost => cost.CostsId !== costsId)
    }))
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '10px', marginTop: '10px' }}>
      {/* movimento atribuir numero de contentor, Levantar Contentor e Entregar Contentor ✅ */}
      {(dataChangeState === 'EC' || dataChangeState === 'LC') && (
        <M_InputTextField
          label={t("ContainerNumber")}
          value={dataMovements.ContainerNumber || ''}
          onChange={value => {
            setDataMovements(prev => ({
              ...prev,
              ContainerNumber: value.target.value
            }))
          }}
        />
      )}

      {/* movimento incidencia */}
      {dataChangeState === 'IN' && (
        <div>
          <M_DrawerTableTextField
            width="100%"
            tableLabel={t('Incidence')}
            label={t('Incidence')}
            entity="ServiceOrderStateReason"
            value={
              dataMovements?.ReasonId
                ? { ReasonId: dataMovements.ReasonId, Name: dataMovements.Name }
                : null
            }
            filterField="Name"
            labelFields={['Name']}
            onSubmitValue={obj =>
              setDataMovements(prev => ({
                ...prev,
                Name: obj ? obj.Name : null,
                ReasonId: obj ? obj.ReasonId : null,
              }))
            }
            valueField="ReasonId"
          />
          <M_TextArea
            label={t('Notes')}
            value={dataMovements.Notes || ''}
            onChange={value => {
              setDataMovements(prev => ({
                ...prev,
                Notes: value.target.value
              }))
            }}
          />
        </div>
      )}

      {/* adicionar chegada ao local e atrelar reboque */}
      {(dataChangeState === 'CL' || dataChangeState === 'AR') && (
        <div>
          <M_Select
            label={t('Local')}
            options={orderServiceAddresses.map((address) => ({
              label: `${address.AddressType || t('Address')} - ${address.AddressCode || t('NoData')}`,
              value: address.ServiceOrderAddressId
            }))}
            value={dataMovements.ServiceOrderAddressId || ''}
            onChange={value => {
              setDataMovements(prev => ({
                ...prev,
                ServiceOrderAddressId: value.target.value,
              }))
            }}
          />
        </div>
      )}

      {/* adicionar campos de desatrelar reboque e colocar no chão - casa do cliente */}
      {(dataChangeState === 'DR' || dataChangeState === 'CC') && (
        <div>
          <M_Select
            label={t('Local')}
            options={orderServiceAddresses.map((address) => ({
              label: `${address.AddressType || t('Address')} - ${address.AddressCode || t('NoData')}`,
              value: address.ServiceOrderAddressId
            }))}
            value={dataMovements.ServiceOrderAddressId || ''}
            onChange={value => {
              setDataMovements(prev => ({
                ...prev,
                ServiceOrderAddressId: value.target.value,
              }))
            }}
          />

          <M_InputTextField
            label={t('CuttOffPickup')}
            type="datetime-local"
            value={dataMovements.CuttOffPickup ? new Date(dataMovements.CuttOffPickup).toISOString().slice(0, 16) : ''}
            onChange={value => {
              setDataMovements(prev => ({
                ...prev,
                CuttOffPickup: value.target.value ? new Date(value.target.value).toISOString() : null
              }))
            }}
          />
        </div>
      )}

      {/* movimento edição do subContratar */}
      {dataChangeState === 'ES' && (
        <div>
          <M_InputTextField
            label={t("Subcontractor")}
            value={dataMovements.Name || ''}
            disabled
          />

          <M_InputTextField
            type="decimal"
            label={t("AgreedValue")}
            value={dataMovements.AgreedValue || ''}
            onChange={value => {
              setDataMovements(prev => ({
                ...prev,
                AgreedValue: value.target.value
              }))
            }}
            iconEnd={<EuroSymbol />}
          />

          <M_DrawerTableTextField
            width="100%"
            tableLabel={t('Costs')}
            label={t('Costs')}
            entity="Costs"
            multiple
            value={selectedSubcontractedCosts}
            filterField="Descriptive"
            labelFields={['Descriptive']}
            onSubmitValue={setSubcontractedCosts}
            valueField="CostsId"
            FILTER={`IsSubcontracted eq true`}
            placeholder={t("SelectCosts")}
          />

          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <strong>{t('Costs')}</strong>
            {selectedSubcontractedCosts.length > 0 ? (
              <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
                {selectedSubcontractedCosts.map((cost) => (
                  <div
                    key={cost.CostsId}
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      gap: '10px',
                      padding: '6px 8px',
                      border: '1px solid var(--color-grey-light)',
                      borderRadius: '6px'
                    }}
                  >
                    <span>
                      {cost.Descriptive || cost.Costs || t('NoData')}
                      {cost.AddicionalPrice !== null && cost.AddicionalPrice !== undefined
                        ? ` - ${cost.AddicionalPrice} EUR`
                        : ''}
                    </span>
                    <DeleteOutline
                      onClick={() => removeSubcontractedCost(cost.CostsId)}
                      style={{ cursor: 'pointer', color: 'var(--color-red)' }}
                    />
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ fontSize: '12px' }}>{t('NoCosts')}</div>
            )}
          </div>
        </div>
      )}
    </div>
  )
}

export default function ExecutionBoard({ roles }) {

  const [line, setLine] = useState(null)
  const [modalChangeState, setModalChangeState] = useState(false)
  const [dataMovements, setDataMovements] = useState({})
  const [dataChangeState, setDataChangeState] = useState('')
  const [dataChangeStateId, setDataChangeStateId] = useState(null)
  const [optionsState, setOptionsState] = useState([])
  const [refresh, setRefresh] = useState(false)
  const [historyMovements, setHistoryMovements] = useState([])
  const [orderServiceAddresses, setOrderServiceAddresses] = useState([])
  const [modalHistoryMovements, setModalHistoryMovements] = useState(false)
  const getMovementType = new BufferService('ServiceOrderStateMovementType')
  const submitMovement = new BufferService('ServiceOrderChangeState/change-state')
  const bufferServiceHistoryMovements = new BufferService('ServiceOrderChangeState')
  const bufferServiceOrderAddress = new BufferService('ServiceOrderAddress')
  const ctx = useContext(LoadingContext)
  const ctx2 = useContext(NavigateContext)
  const { t } = useTranslation()

  const optionsTrinomial = [
    { Name: 'Trinomial', NormalizedName: t('Trinomial'), type: 'string', IsDisabled: false, IsRequired: true, IsHiddenList: false, ForeignTableToPassId: 'TrinomialAssignId', ForeignTableName: 'AvailableTrinomialBoardView', ForeignKeyName: 'Transport' },
  ]

  const changeState = () => {
    if (line) {
      ctx.setIsLoad(true)
      const filter = `?$filter=ServiceOrderStateId eq ${line[0].ServiceOrderStateId} &$orderby=ServiceOrderMovementTypeId asc`

      getMovementType.filter(filter).then(response => {
        if (response.name === 'AxiosError') {
          ctx.toastMessages('error', response.response.data.Errors.toString(), '')
          ctx.setIsLoad(false)
          return
        }
        setOptionsState(response.Items)
        setModalChangeState(true)
        ctx.setIsLoad(false)
      })

    } else {
      ctx.toastMessages('warning', t("SelectedLine"), '')
    }
  }

  const submitChangeState = () => {
    setDataChangeState('')
    const tempObject = {
      ServiceOrderId: line[0].ServiceOrderId,
      ServiceOrderMovementTypeId: dataChangeStateId,
      MovDate: new Date().toISOString(),
      ...dataMovements
    }
    if (tempObject.ServiceOrderMovementTypeId === '') {
      ctx.toastMessages("error", '', t("SelectOneMovement"))
      return
    }

    submitMovement.post(tempObject).then(response => {
      if (response.name === 'AxiosError') {
        ctx.toastMessages('error', response.response.data.Errors.toString(), '')
        return
      }
      ctx.toastMessages('success', t("ChangeStateSuccess"), '')
      setDataMovements({})
      setModalChangeState(false)
      setDataChangeStateId(null)
      setRefresh(true)
    })
  }

  const viewOrderService = () => {
    if (line) {
      const current = ctx.passValue instanceof Map ? ctx.passValue : new Map()
      const newMap = new Map(current)
      newMap.set("lines", line[0])

      ctx.setPassValue(newMap)

      ctx2.newTab('viewOrderService', `${t("NumberOrder")} #${line[0].ServiceOrderId}`)
    } else {
      ctx.toastMessages('warning', t("SelectedLine"), '')
    }
  }

  const viewHistoryMovements = () => {
    if (line) {
      ctx.setIsLoad(true)
      bufferServiceHistoryMovements.filter(`?filter=serviceOrderId eq ${line[0].ServiceOrderId}`).then((respHistory) => {
        if (respHistory.name === 'AxiosError') {
          ctx.toastMessages('error', respHistory.response.data.Errors[0], '')
          return
        }
        setHistoryMovements(respHistory.Items)
        setModalHistoryMovements(true)
        ctx.setIsLoad(false)
      })
    } else {
      ctx.toastMessages('warning', t("SelectedLine"), '')
    }
  }

  const getAddressOrderService = async (serviceOrderId) => {
    const response = await bufferServiceOrderAddress.filter(`?$filter=ServiceOrderId eq ${serviceOrderId}`)
    if (response.name === 'AxiosError') {
      ctx.toastMessages('error', response.response.data.Errors.toString(), '')
      return []
    }
    const addresses = response.Items || []
    setOrderServiceAddresses(addresses)
    return addresses
  }

  const normalizeSubcontractMovement = (movement) => {
    if (!movement) return {}

    const subcontractedCosts = (movement.SubcontractedCosts || []).reduce((acc, cost) => {
      if (!cost?.CostsId || acc.some(item => item.CostsId === cost.CostsId)) return acc

      return [...acc, {
        CostsId: cost.CostsId,
        Descriptive: cost.Descriptive || cost.Costs || cost.Name || '',
        AddicionalPrice: cost.AddicionalPrice ?? cost.Value ?? null,
      }]
    }, [])

    return {
      CarrierId: movement.CarrierId || null,
      Name: movement.Name || movement.CarrierName || movement.SubcontractorName || '',
      AgreedValue: movement.AgreedValue || '',
      SubcontractedCosts: subcontractedCosts,
    }
  }

  const getLatestMovementByType = (items, movementTypeId) => {
    const parseMovDate = (item) => {
      const date = new Date(item?.MovDate || 0).getTime()
      return Number.isNaN(date) ? 0 : date
    }

    return items
      .filter(item => Number(item?.ServiceOrderMovementTypeId) === Number(movementTypeId))
      .sort((a, b) => parseMovDate(b) - parseMovDate(a))[0] || null
  }

  const getSubcontractDataForMovement16 = async (serviceOrderId) => {
    const response = await bufferServiceHistoryMovements.filter(`?filter=serviceOrderId eq ${serviceOrderId}`)

    if (response.name === 'AxiosError') {
      ctx.toastMessages('error', response.response?.data?.Errors?.toString() || t("NoData"), '')
      return null
    }

    const historyItems = response?.Items || []
    if (historyItems.length === 0) return {}

    const latestMovement16 = getLatestMovementByType(historyItems, 16)
    const latestMovement5 = getLatestMovementByType(historyItems, 5)
    const movementToUse = latestMovement16 || latestMovement5

    return normalizeSubcontractMovement(movementToUse)
  }

  useEffect(() => {
    if (!modalChangeState || !line?.[0]?.ServiceOrderId) return

    if (dataChangeState === 5 || dataChangeState === 12 || dataChangeState === 11 || dataChangeState === 14) {
      getAddressOrderService(line[0].ServiceOrderId)
      return
    }

    setOrderServiceAddresses([])
  }, [dataChangeState, modalChangeState, line])

  useEffect(() => {
    if (!modalChangeState || !line?.[0]?.ServiceOrderId || dataChangeState !== 'ES') return

    const loadSubcontractData = async () => {
      ctx.setIsLoad(true)
      const subcontractData = await getSubcontractDataForMovement16(line[0].ServiceOrderId)

      if (subcontractData) {
        setDataMovements(prev => ({
          ...prev,
          ...subcontractData
        }))
      }

      ctx.setIsLoad(false)
    }

    loadSubcontractData()
  }, [dataChangeState, modalChangeState, line])

  return (
    <div>
      <M_Table
        entityName={'ServiceOrderExecutionBoardView'}
        rolePermissions={roles}
        filtersOnTable
        refresh={refresh}
        setRefresh={setRefresh}
        selectSingle
        onPassLine={(line) => {
          if (!line || (Array.isArray(line) && line.length === 0)) {
            setLine(null)
          } else {
            setLine(line)
          }
        }}
        extraButtons={[
          { label: t('ChangeMovement'), element: 'default', source: '/icons/svgsDaNet/arrows-shuffle.svg', style: {}, command: () => { changeState() } },
          { label: t('OrderServiceView'), element: 'default', source: '/icons/svgsDaNet/eye-blue.svg', style: {}, command: () => { viewOrderService() } },
          { label: t('HistoryMovements'), element: 'default', source: '/icons/svgsDaNet/history.svg', style: {}, command: () => { viewHistoryMovements() } }
        ]}
      />

      <M_MessageBoard
        open={modalChangeState}
        title={t('ChangeMovement')}
        onClose={() => setModalChangeState(false)}
        body={<div style={{ minWidth: '300px' }}>
          <M_Select
            label={t('SelectMovement')}
            options={optionsState.map(state => ({
              label: state.MovementType,
              value: state.MovementTypeCode
            }))}
            value={dataChangeState || ''}
            onChange={value => {
              const selectedMovement = optionsState.find(state => state.MovementTypeCode === value.target.value)
              setDataChangeState(value.target.value)
              setDataChangeStateId(selectedMovement?.ServiceOrderMovementTypeId ?? null)
              setDataMovements({})
            }}
          />
          <div>
            <Body
              dataChangeState={dataChangeState}
              dataMovements={dataMovements}
              setDataMovements={setDataMovements}
              optionsTrinomial={optionsTrinomial}
              orderServiceAddresses={orderServiceAddresses}
              t={t}
            />

          </div>
          <div style={{ display: 'flex', alignItems: 'flex-start', marginTop: '10px', gap: '5px' }}>
            <img src="/icons/svgsDaNet/alert-triangle.svg" alt="alert" style={{ width: '20px' }} />
            {t("InfoSendEmailChangeState")}
          </div>
        </div>}
        footer={<div className='divFooterAlertsOrderService'>
          <M_Button
            backgroundColor={'var(--color-red)'}
            label={t("Close")}
            labelColor={'var(--color-white)'}
            onClick={() => {
              setModalChangeState(false)
              setDataChangeState('')
              setDataMovements({})
              setOrderServiceAddresses([])
            }}
          />
          <M_Button
            backgroundColor={'var(--color-green)'}
            label={t("Save")}
            labelColor={'var(--color-white)'}
            onClick={submitChangeState}
          />
        </div>}
      />

      <M_MessageBoard
        open={modalHistoryMovements}
        title={t('HistoryMovements')}
        onClose={() => setModalHistoryMovements(false)}
        minWidth={'80%'}
        body={
          historyMovements.length !== 0 ? (
            <div style={{ width: '100%' }}>
              <div className='tableHistoryMovementsOrderService'>
                <div style={{ textAlign: 'center' }}>{t("Status")}</div>
                <div style={{ textAlign: 'center' }}>{t("DateChange")}</div>
                <div style={{ textAlign: 'center' }}>{t("Trinomial")}</div>
                <div style={{ textAlign: 'center' }}>{t("Notes")} </div>
                <div style={{ textAlign: 'center' }}>{t("MovementName")}</div>
                <div style={{ textAlign: 'center' }}>{t("CreatedBy")} </div>
              </div>
              <div>
                {historyMovements?.map((elem, key) => (
                  <div key={key} className='divRowHistoryMovementsOrderService'>
                    <div style={{ textAlign: 'center', display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '8px' }}>
                      <div style={{ backgroundColor: elem.ServiceOrderWorkflowFromStateColor || "#000000" }} className='divIndicatorStatusHistoryMovementsOrderService'>
                        {elem.ServiceOrderWorkflowFromState}
                      </div>
                      <span>→</span>
                      <div style={{ backgroundColor: elem.ServiceOrderWorkflowToStateColor || "#000000" }} className='divIndicatorStatusHistoryMovementsOrderService'>
                        {elem.ServiceOrderWorkflowToState}
                      </div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      {new Date(elem.MovDate).toLocaleString('pt-PT', { day: '2-digit', month: '2-digit', year: 'numeric' })}
                    </div>
                    <div style={{ textAlign: 'center' }}>{elem.TransportName ? `${elem.TrailerName} + ${elem.DriverName} + ${elem.TransportName}` : t("NoData")}</div>
                    <div style={{ textAlign: 'center' }}>{elem.Notes || t("NoData")}</div>
                    <div style={{ textAlign: 'center' }}>{elem.ServiceOrderMovementTypeName || t("NoData")}</div>
                    <div style={{ textAlign: 'center' }}>{elem.CreatedBy || t("NoData")}</div>
                  </div>
                ))}
              </div>
            </div>
          ) : t("NoData")
        }
        footer={
          <M_Button
            backgroundColor={'var(--color-red)'}
            label={t("Close")}
            labelColor={'var(--color-white)'}
            onClick={() => {
              setModalHistoryMovements(false)
              setHistoryMovements([])
            }}
          />
        }
      />
    </div>
  )
}
